import React from "react";
import { Box, Flex } from "rebass/styled-components";

import { CallToActionContent, IconPack } from "../../../models/app-data-model";
import ButtonWrapper from "../../button-wrapper/button-wrapper";
import "./low-impact-cta.scss";

export type LowImpactCtaProps = {
  content: CallToActionContent;
  iconPack: IconPack[];
};

const LowImpactCta: React.FC<LowImpactCtaProps> = ({ content, iconPack }: LowImpactCtaProps) => {
  const { header, subtext, primary_button: primaryButton, secondary_button: secondaryButton } = content;

  return (
    <Flex className="low-impact-cta-content" width={1} padding={[5, 5, 5, 5, 6]} justifyContent="center">
      <Box className="text-container" width={[1, 1, 1, 1, 2 / 3]}>
        {header && <h3 className="heading">{header}</h3>}
        {subtext && <p className="subtext">{subtext}</p>}
      </Box>
      <div className="button-section">
        {primaryButton?.text && primaryButton?.reference && (
          <div className="btn-container">
            <ButtonWrapper
              iconPack={iconPack}
              type="primary"
              styleOverride={"wide-button"}
              label={primaryButton.text}
              reference={primaryButton.reference}
            />
          </div>
        )}
        {secondaryButton?.text && secondaryButton?.reference && (
          <div className="btn-container">
            <ButtonWrapper
              iconPack={iconPack}
              type="secondary"
              styleOverride={"wide-button"}
              label={secondaryButton.text}
              reference={secondaryButton.reference}
            />
          </div>
        )}
      </div>
    </Flex>
  );
};

export default LowImpactCta;
